var _rect, _path, _path2, _path3, _path4, _text, _line, _text2, _circle, _circle2, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 70,
    height: 70,
    rx: 15,
    fill: "#f66767"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 40 Q35 30 45 40 Q55 50 65 40",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 50 Q35 40 45 50 Q55 60 65 50",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 60 Q35 50 45 60 Q55 70 65 60",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30 L45 70 M25 50 L65 50",
    stroke: "#CAF0F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 50,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 28,
    fill: "#ffffff"
  }, "PASS")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 60,
    x2: 300,
    y2: 60,
    stroke: "#ffffff",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#ffffff"
  }, "Polio Assessment Sequence Screening")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 30,
    r: 5,
    fill: "#f4f4f4",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 45,
    r: 5,
    fill: "#f4f4f4",
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 30,
    x2: 275,
    y2: 30,
    stroke: "#f4f4f4",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 45,
    x2: 275,
    y2: 45,
    stroke: "#f4f4f4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassLog);
export default __webpack_public_path__ + "static/media/passLog.d8fbf179ff18d6ebd9d9483be31e565a.svg";
export { ForwardRef as ReactComponent };